/* Kasutam theme — scroll-reveal animations for elements marked .scroll-trigger */
(function () {
  'use strict';

  function initScrollAnimations() {
    var targets = document.querySelectorAll('.scroll-trigger');
    if (!targets.length) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.remove('scroll-trigger--offscreen');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    targets.forEach(function (el, index) {
      // Anything already in view stays visible (no hide-then-reveal flash);
      // only elements below the fold are hidden and revealed on scroll.
      var rect = el.getBoundingClientRect();
      if (rect.top < viewportHeight) {
        return;
      }
      el.classList.add('scroll-trigger--offscreen');
      el.style.animationDelay = Math.min(index * 0.06, 0.4) + 's';
      observer.observe(el);
    });
  }

  document.addEventListener('DOMContentLoaded', initScrollAnimations);
})();
